import { render } from "./link.vue?vue&type=template&id=153cdcfe"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"

import "./link.vue?vue&type=style&index=0&id=153cdcfe&lang=css"
script.render = render

export default script